export default "__VITE_ASSET__BbWk1fH___"